// export modules from here
import { spawn as cpSpawn } from "child_process";

export const spawn = async (command, args, options) =>
  new Promise((resolve, reject) => {
    const { stdout, stderr, ...commandOptions } = options;
    const spawnedProcess = cpSpawn(command, args, commandOptions);

    spawnedProcess.stdout.on("data", (data) => {
      // check if stdout exists and is a function
      if (stdout && typeof stdout === "function") {
        stdout(data.toString());
      }
    });

    spawnedProcess.stderr.on("data", (data) => {
      // check if stderr exists and is a function
      if (stderr && typeof stderr === "function") {
        stderr(data.toString());
      }
    });

    spawnedProcess.on("error", (err) => {
      console.error("error", err);
      reject(err);
    });

    spawnedProcess.on("close", (code) => {
      resolve(code);
    });
  });
